export default __webpack_public_path__ + "static/media/moon.c56a980e.svg";